import type { ReactNode, Dispatch, SetStateAction } from 'react';
import { createContext, useMemo } from 'react';
// import { useLocationLegacy as useLocation } from '@leagueplatform/routing';
import { BasePage } from 'components/BasePage';

const showNavigationDefault = true;

export const BasePageContext = createContext<{
  setShowNavigation: Dispatch<SetStateAction<boolean>>;
}>({
  setShowNavigation: () => showNavigationDefault,
});

export const BasePageProvider = ({ children }: { children: ReactNode }) => {
  // const { pathname, search } = useLocation();
  // const queryParams = new URLSearchParams(search);
  // const isFromGetStarted = queryParams.get('fs') === 'true';
  // const showNavigation = !(
  //   isFromGetStarted &&
  //   (pathname.startsWith('/messages/') ||
  //     pathname.startsWith('/health-journey/'))
  // );

  const basePageContextValue = useMemo(
    () => ({
      setShowNavigation: () => {},
    }),
    [],
  );

  return (
    <BasePageContext.Provider value={basePageContextValue}>
      <BasePage>{children}</BasePage>
    </BasePageContext.Provider>
  );
};
